import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';
import UserListPage from '@features/users/UserListPage';

export const Route = createFileRoute('/w/users/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'effectiveFrom', sortDir: 'desc', tab: 'ALL' }),
  component: WorkpayUsersPage,
});

function WorkpayUsersPage() {
  const searchParams = Route.useSearch();
  return <UserListPage routeTo="/w/users" searchParams={searchParams} />;
}
